<template>
  <div
    @click.stop="backgroundDismissable && updateState(false)"
    :class="{ 'modal-open': modelValue }"
    class="modal"
  >
    <div class="modal-box" @click.stop>
      <slot></slot>
      <div class="modal-action" v-if="showCloseButton">
        <button @click="closeModal" class="btn">Fermer</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalBox",
  props: {
    modelValue: {
      type: Boolean,
      required: true,
      default: false,
    },

    showCloseButton: {
      type: Boolean,
      required: true,
      default: false,
    },

    backgroundDismissable: {
      type: Boolean,
      required: true,
      default: true,
    },
  },

  methods: {
    updateState(state) {
      this.$emit("update:modelValue", state);
    },

    closeModal() {
      this.updateState(false);
      this.$emit("close");
    },
  },
};
</script>

<style>
</style>
